import React, { useState, useEffect } from "react";
import userService from "../services/userService";
import roleService from "../services/roleService";
import AddUserForm from "../components/AddUserForm";
import RoleManagementForm from "../components/RoleManagementForm";
import { useStateContext } from "../contexts/ContextProvider";
import { FaEdit, FaTimes, FaTrashAlt } from "react-icons/fa";
import { TiUserAdd } from "react-icons/ti";
import { FaRegAddressBook } from "react-icons/fa6";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import DeleteConfirmationModal from "../components/DeleteConfirmationModal";
import { GiCancel } from "react-icons/gi";
import Select from "react-select";
import SearchBox from "react-search-box";

import { colors } from "@mui/material";
import { Button, Modal } from "react-bootstrap";
import AddUpdateUser from "../components/UserRole/AddUpdateUser";
import RoleManagement from "../components/UserRole/RoleManagement";
import UserRole from "../components/UserRole/UserRole";
const UserManage = () => {
  const [users, setUsers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showAddUserForm, setShowAddUserForm] = useState(false);
  const [showRoleManagementForm, setShowRoleManagementForm] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [roles, setRoles] = useState([]);
  const { currentColor, currentMode } = useStateContext();
  const [searchValue, setSearchValue] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [allUsers, setAllUsers] = useState([]);
  const [itemToDelete, setItemDelete] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState([
    { value: "all", label: "All Roles" },
  ]);
  const [options, setOptions] = useState([]);

  const getCustomStyles = (currentMode) => ({
    control: (provided) => ({
      ...provided,
      border: currentMode === "Dark" ? "1px solid #444" : "1px solid #ccc",
      boxShadow: "none",
      backgroundColor: currentMode === "Dark" ? "#33373E" : "#fff",
      "&:hover": {
        border: currentMode === "Dark" ? "1px solid #666" : "1px solid #aaa",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#007bff"
        : state.isFocused
        ? currentMode === "Dark"
          ? "#555"
          : "#f0f0f0"
        : currentMode === "Dark"
        ? "#333"
        : "#fff",
      color: state.isSelected
        ? "#fff"
        : currentMode === "Dark"
        ? "#ddd"
        : "#000",
    }),
    menu: (provided) => ({
      ...provided,
      border: currentMode === "Dark" ? "1px solid #444" : "1px solid #ccc",
      backgroundColor: currentMode === "Dark" ? "#333" : "#fff",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: currentMode === "Dark" ? "#888" : "#888",
    }),
  });

  const fetchUsers = async (search = "", filter = "", roles_filter = []) => {
    try {
      let roleslist = roles.map((role) => role.name);

      if (roleslist.length == 0) {
        roleslist = roles_filter.map((role) => role.name);
      }
      console.log(roleslist);
      const userlimit = {
        start_user: 0,
        end_user: 20,
        search_filter: true,
        // Search_scorl: false,
        searchValue: search,
        filterByRoleType: filter == "all" ? roleslist : filter,
      };
      const data = await userService.getUsers(userlimit);
      console.log(data, "***********");
      setUsers(data);

      setAllUsers(data);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  // const fetchUsers = async (search = "", filter = [], roles_filter = []) => {
  //   try {
  //     console.log(
  //       "Fetching users with search:",
  //       search,
  //       "and filters:",
  //       filter
  //     );
  //     let roleslist = roles.map((role) => role.name);
  //     if (
  //       roleslist.length === 0 ||
  //       filter.find((option) => option.value === "all")
  //     ) {
  //       roleslist = roles_filter.map((role) => role.name);
  //     }

  //     console.log(roleslist);
  //     console.log("Selected filters:", filter);

  //     const userlimit = {
  //       start_user: 0,
  //       end_user: 20,
  //       search_filter: true,
  //       // Search_scorl: false,
  //       searchValue: search,
  //       filterByRoleType:
  //         filter.length === 0 || filter.find((option) => option.value === "all")
  //           ? roleslist
  //           : filter.map((option) => option.value),
  //     };
  //     const data = await userService.getUsers(userlimit);
  //     console.log(data, "***********");
  //     setUsers(data);

  //     setAllUsers(data);
  //   } catch (error) {
  //     console.error("Error fetching users:", error);
  //   }
  // };
  const fetchRoles = async () => {
    try {
      const data = await userService.getRoles();
      console.log(data); // Check the fetched data
      setRoles(data);
      const optionsData = data.map((role) => ({
        value: role.name,
        label: role.name,
      }));
      setOptions(optionsData);
      if (data) {
        return data;
      } else {
        return false;
      }
      // setSelectedFilters(optionsData);
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  useEffect(async () => {
    await fetchRoles().then((roles) => {
      console.log(roles);
      fetchUsers("", "all", roles);
    });
  }, []);

  // const fetchRoles = async () => {
  //   try {
  //     const data = await userService.getRoles();
  //     setRoles(data);

  //     if (data) {
  //       return data;
  //     } else {
  //       return false;
  //     }
  //   } catch (error) {
  //     console.error("Error fetching roles:", error);
  //   }
  // };

  const handleEdit = (user) => {
    setSelectedUser(user);
    setShowAddUserForm(true);
    // setShowModal(true);
  };

  const handleDelete = async () => {
    try {
      const delet_user = await userService.deleteUser(itemToDelete);
      if (delet_user?.success) {
        toast.success("User deleted successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      fetchUsers("", selectedFilter, roles);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Error deleting user", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const handleFormSubmit = async (values, { setSubmitting }) => {
    try {
      if (selectedUser) {
        const updateUser = await userService.updateUser(
          selectedUser._id,
          values
        );

        if (updateUser.success) {
          toast.success("User Details Updated successfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      } else {
        const newUser = await userService.addUser(values);

        if (newUser.success) {
          toast.success("User created successfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }
      setSubmitting(false);
      setShowModal(false);
      setShowAddUserForm(false);
      await fetchUsers("", selectedFilter, roles);
    } catch (error) {
      console.error("Error:", error);
      toast.error(error?.response?.data?.message || "Error creating user", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const handleAddRole = async (values, { setSubmitting, resetForm }) => {
    try {
      console.log(values, "val");
      const RoleAdd = await roleService.addRole(values);
      if (RoleAdd?.success) {
        toast.success("Role created successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      setSubmitting(false);
      resetForm();
      fetchRoles();
      return RoleAdd;
    } catch (error) {
      toast.error(error?.response?.data?.message || "Error Creating Role", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.error("Error adding role:", error);
      setSubmitting(false);
    }
  };

  const handleUpdateRole = async (values, { setSubmitting, resetForm }) => {
    try {
      const role_update = await roleService.updateRole(values.selectedRole, {
        name: values.updatedRoleName,
      });
      if (role_update?.success) {
        toast.success("Role updated successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      setSubmitting(false);
      resetForm();
      fetchRoles();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Error Updating Role", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.error("Error updating role:", error);
      setSubmitting(false);
    }
  };

  const openAddUserForm = () => {
    if (!showAddUserForm) {
      setSelectedUser(null);
      setShowAddUserForm(true);
      setShowRoleManagementForm(false);
    }
    setShowModal(true);
  };

  const openRoleManagementForm = () => {
    setShowAddUserForm(false);
    setShowRoleManagementForm(true);
    setShowModal(true);
  };
  const closeModel = () => {
    setShowModal(false);
    setShowAddUserForm(false);
    setShowRoleManagementForm(false);
  };
  const handleSearchChange = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchValue(value);

    const filtered_users = allUsers.filter(
      (user) =>
        user.firstname.toLowerCase().includes(value) ||
        user.lastname.toLowerCase().includes(value) ||
        user.username.toLowerCase().includes(value) ||
        user.email.toLowerCase().includes(value) ||
        user.role.role.toLowerCase().includes(value)
    );
    setUsers(filtered_users);
  };
  const handleFilterChange = (selectedOptions) => {
    const filtered_roles = selectedOptions.map((role) => role.value);

    setSelectedFilters(selectedOptions || []);

    if (
      selectedOptions &&
      selectedOptions.find((option) => option.value === "all")
    ) {
      fetchUsers("", "all", roles);
    } else {
      fetchUsers("", filtered_roles.length ? filtered_roles : "all", roles);
    }
  };

  const handleDeleteModal = (id) => {
    setItemDelete(id);
    setDeleteModal(true);
  };
  const handleclose = () => {
    setDeleteModal(false);
  };

  return (
    <>
      <div className="p-2">
        {/* <h1 className="text-2xl font-bold mb-4">User Management</h1> */}

        <div className="flex justify-end space-x-2 ">
          <div className="flex space-x-2">
            <Select
              options={[{ value: "all", label: "All Roles" }, ...options]}
              value={selectedFilters}
              onChange={(e) => handleFilterChange(e)}
              placeholder="Select roles"
              isMulti
              classNamePrefix="react-select"
              styles={getCustomStyles(currentMode)}
            />

            <input
              type="text"
              className={`px-2 py-1  ${
                currentMode === "Dark"
                  ? "text-white bg-[#33373E]"
                  : "bg-white border"
              }`}
              placeholder="Search..."
              value={searchValue}
              onChange={handleSearchChange}
            />
          </div>
          <div className="flex items-center">
            <TooltipComponent
              content="Add user or Manage Roles"
              position="BottomCenter"
            >
              <button
                className="flex items-center justify-center px-2 py-2 bg-blue-500 text-white rounded-full hover:bg-blue-600"
                onClick={() => setShowModal(true)}
                style={{ backgroundColor: currentColor }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                  />
                </svg>
              </button>
            </TooltipComponent>
          </div>
        </div>
      </div>

      <hr className="border-gray-500 border-1 p-0 m-0" />

      <div className=" mx-8 my-4 p-2">
        {users.length === 0 ? (
          <div style={{ width: "100%", height: "400px" }}>
            <div className="flex justify-center items-center">
              <p className="text-xl font-bold ">No users found.</p>
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
            {users.map((user) => (
              <div
                key={user._id}
                className={`p-4 shadow-md relative flex flex-col items-center ${
                  currentMode === "Dark"
                    ? "text-white bg-[#33373E]"
                    : "bg-white"
                }`}
                style={{ fontFamily: "Poppins" }}
              >
                <div
                  className="flex justify-center items-center relative "
                  style={{
                    backgroundColor: currentColor,
                    top: "-12%",
                    // top: "-15%",
                    // left: " 44%",
                    // transform: " translate(-50%, -50%)",
                    height: "50px",
                    width: "100px",
                    borderRadius: " 0 0 50% 50%/0 0 100% 100%",
                    // borderTopLeftRadius: "0",
                    // borderTopRightRadius: "0",
                    // borderBottomLeftRadius: "100%",
                    // borderBottomRightRadius: "100%",
                  }}
                >
                  <img
                    src="/icons/clipart-user.svg"
                    alt="User Icon"
                    className="w-14 h-14"
                    style={{ filter: "invert(1)" }}
                  />
                </div>
                <div className="text-center mt-2 flex flex-col w-full max-w-xs mx-auto">
                  <p className="text-sm break-words">
                    {user.firstname} {user.lastname}
                  </p>
                  <p
                    style={{ marginBottom: "1px" }}
                    className="text-xs break-words"
                  >
                    {user.role.name}
                  </p>
                  <p
                    className="text-xs break-words"
                    style={{ marginBottom: "1px" }}
                  >
                    {user.email}
                  </p>
                  <p
                    className="text-xs break-words"
                    style={{ marginBottom: "2rem" }}
                  >
                    {user.mobile}
                  </p>
                </div>

                <div className="flex space-x-2 mt-4 justify-center absolute bottom-4">
                  <TooltipComponent content="Edit" position="BottomCenter">
                    <button
                      className="px-2 py-2 text-white rounded-lg transition duration-300 ease-in-out hover:bg-gray-700"
                      style={{ backgroundColor: currentColor }}
                      onClick={() => handleEdit(user)}
                    >
                      {/* <FaEdit /> */}
                      <span
                        style={{
                          mask: `url(/icons/edit-icon.svg) center no-repeat`,
                          WebkitMask: `url(/icons/edit-icon.svg) center no-repeat`,
                          maskSize: "contain",
                          WebkitMaskSize: "contain",
                          display: "block",
                          width: "15px",
                          height: "15px",
                          backgroundColor: "white",
                          transition: "background-color 0.3s",
                        }}
                      ></span>
                    </button>
                  </TooltipComponent>
                  <TooltipComponent content="Delete" position="BottomCenter">
                    <button
                      className="px-2 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
                      onClick={() => handleDeleteModal(user._id)}
                      style={{ backgroundColor: currentColor }}
                    >
                      <span
                        style={{
                          mask: `url(/icons/delete-icon.svg) center no-repeat`,
                          WebkitMask: `url(/icons/delete-icon.svg) center no-repeat`,
                          maskSize: "contain", // Adjust the mask size here
                          WebkitMaskSize: "contain",
                          display: "block",
                          width: "15px",
                          height: "15px",
                          backgroundColor: "white",
                          transition: "background-color 0.3s",
                        }}
                      ></span>
                      {/* <FaTrashAlt /> */}
                    </button>
                  </TooltipComponent>
                </div>
              </div>
            ))}
          </div>
        )}

        <AddUpdateUser
          showAddUserForm={showAddUserForm}
          closeModel={closeModel}
          roles={roles}
          selectedUser={selectedUser}
          handleFormSubmit={handleFormSubmit}
        />
        <RoleManagement
          showRoleManagementForm={showRoleManagementForm}
          closeModel={closeModel}
          roles={roles}
          handleAddRole={handleAddRole}
          handleUpdateRole={handleUpdateRole}
        />

        <UserRole
          showModal={showModal}
          closeModel={closeModel}
          openAddUserForm={openAddUserForm}
          openRoleManagementForm={openRoleManagementForm}
        />
        {/* {Add user or rolemanagement} */}

        {deleteModal && (
          <DeleteConfirmationModal
            onClose={handleclose}
            onDelete={handleDelete}
          />
        )}
        <ToastContainer />
      </div>
    </>
  );
};

export default UserManage;
